import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Link } from '../../elements';

import styles from './navigation.scss';

const Navigation = ({ linkTo, className, color }) => (
  <div className={styles.navigation}>
    <Link linkTo={linkTo}>
      <Icon name="icon-arrow" color={color}/>
    </Link>
  </div>
);

Navigation.propTypes = {
  color: PropTypes.string,
  linkTo: PropTypes.string,
};

export { Navigation };



// WEBPACK FOOTER //
// ./src/components/navigation/navigation.js